"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailTaxType = void 0;
var DetailTaxType;
(function (DetailTaxType) {
    DetailTaxType["EXCLUSIVE"] = "exclusive";
    DetailTaxType["INCLUSIVE"] = "inclusive";
})(DetailTaxType = exports.DetailTaxType || (exports.DetailTaxType = {}));
